import i18n from "@/locales/index"

export default [
  [
    {
      name: "seperator2",
      type: "seperator",
      size: {
        md: 12,
        lg: 12,
      },
    },
  ],
  [
    {
      name: "Address-FirstName",
      label: i18n.tc("firstName2"),
      type: "text",
      placeholder: i18n.tc("enterYourFirstname"),
      required: true,
      maxLength: 50,
    },
    {
      name: "Address-LastName",
      label: i18n.tc("lastName2"),
      type: "text",
      placeholder: i18n.tc("enterYourLastname"),
      required: true,
      maxLength: 50,
    },
    {
      name: "Address-CompanyName",
      label: i18n.tc("companyName"),
      type: "text",
      placeholder: i18n.tc("enterCompanyName"),
      required: false,
      maxLength: 50,
    },
    {
      name: "Address-Tel",
      label: i18n.tc("phoneNumber"),
      type: "text",
      placeholder: i18n.tc("enterYourPhonenumber"),
      required: true,
      maxLength: 20,
    },
    {
      name: "Address-Street",
      label: i18n.tc("streetName"),
      type: "text",
      placeholder: i18n.tc("enterTheNameOfYourStreet"),
      required: true,
      maxLength: 50,
    },
    {
      name: "Address-HouseNumber",
      label: i18n.tc("houseNumber"),
      type: "text",
      placeholder: i18n.tc("enterYourHouseNumber"),
      required: true,
      maxLength: 10,
    },
    {
      name: "Address-HouseNumberAddition",
      label: i18n.tc("houseNumberAddition2"),
      type: "text",
      placeholder: i18n.tc("enterYourHouseNumberAddition"),
      required: false,
      maxLength: 10,
    },
    {
      name: "Address-ZipCode",
      label: i18n.tc("zipcode"),
      type: "text",
      placeholder: i18n.tc("enterYourZipcode"),
      required: true,
      maxLength: 10,
    },
    {
      name: "Address-City",
      label: i18n.tc("city"),
      type: "text",
      placeholder: i18n.tc("enterTheNameOfYourCity"),
      required: true,
      maxLength: 50,
    },
    {
      name: "Address-CountryID",
      label: i18n.tc("country"),
      type: "select",
      options: [
        { text: "Albania", value: "AL" },
        { text: "Austalia", value: "AU" },
        { text: "Austria", value: "AT" },
        { text: "Azerbaidjan", value: "AZ" },
        { text: "Belgium", value: "BE" },
        { text: "Bosnia-Herzegovina", value: "BA" },
        { text: "Bulgaria", value: "BG" },
        { text: "Croatia", value: "HR" },
        { text: "Cyprus", value: "CY" },
        { text: "Czech Republic", value: "CZ" },
        { text: "Denemarken", value: "DK" },
        { text: "Estonia", value: "EE" },
        { text: "Finland", value: "FI" },
        { text: "France", value: "FR" },
        { text: "Georgia", value: "GE" },
        { text: "Germany", value: "DE" },
        { text: "Great Britain", value: "GB" },
        { text: "Greece", value: "GR" },
        { text: "Hungary", value: "HU" },
        { text: "Iceland", value: "IS" },
        { text: "Ireland", value: "IE" },
        { text: "Italy", value: "IT" },
        { text: "Latvia", value: "LV" },
        { text: "Liechtenstein", value: "LI" },
        { text: "Lithuania", value: "LT" },
        { text: "Luxembourg", value: "LU" },
        { text: "Macedonia", value: "MK" },
        { text: "Malta", value: "MT" },
        { text: "Moldavia", value: "MD" },
        { text: "Monaco", value: "MC" },
        { value: "NL", text: i18n.tc("theNetherlands"), selected: true },
        { text: "Norway", value: "NO" },
        { text: "Poland", value: "PL" },
        { text: "Portugal", value: "PT" },
        { text: "Romania", value: "RO" },
        { text: "Russia", value: "RU" },
        { text: "Slovak Republic", value: "SK" },
        { text: "Slovenia", value: "SI" },
        { value: "ZA", text: "South Africa" },
        { text: "South Korea", value: "KR" },
        { text: "Spain", value: "ES" },
        { text: "Sweden", value: "SE" },
        { text: "Switzerland", value: "CH" },
        { text: "Turkey", value: "TR" },
        { text: "Ukraine", value: "UA" },
        { text: "USA", value: "US" },
      ],
      placeholder: i18n.tc("enterTheNameOfYourCountry"),
      required: true,
      maxLength: 20,
    },
  ],
]
